import * as he from 'he';

const decodeHtml = he.decode;

export {
    decodeHtml,
    decodeHtml as default
};
